export class TaskType {
    // Individual roles
    static INBOUND_FLIGHT = 'InboundFlight';
    static OUTBOUND_FLIGHT = 'OutboundFlight';
    static TERMINAL = 'Terminal';
    static OTHER = 'Other';

    // Role groups (customize these for convenience)
    static ALL_TASK_TYPES = [
        TaskType.INBOUND_FLIGHT,
        TaskType.OUTBOUND_FLIGHT,
        TaskType.TERMINAL,
        TaskType.OTHER
    ];
  }
